   
<router-outlet></router-outlet>
